/*
 * Copyright 2020 Ladifire. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

import * as React from 'react';
import {useSlotProps, useStyleProps, joinClasses} from '@ladifire-ui-react/utils';
import {DOMProps, StyleProps} from '@react-ui-types/shared';
import {filterDOMProps} from '@react-ui-aria/utils';
import stylex from "@ladifire/stylex";

export interface ShadowProps extends DOMProps, StyleProps {
  show?: boolean;
}

export const Shadow = (props: ShadowProps) => {
  props = useSlotProps(props, 'shadow');

  let {
    show,
    ...otherProps
  } = props;

  let {styleProps} = useStyleProps(otherProps);

  return (
    <div
      {...filterDOMProps(otherProps)}
      {...styleProps}
      className={joinClasses(
        stylex.dedupe(
          show ? {
            boxShadow: '0px 0px 2px -2px rgba(0, 0, 0, 0.2), 0px 2px 4px 0px rgba(0, 0, 0, 0.14), 0px 4px 10px 0px rgba(0, 0, 0, 0.12)',
          } : null,
        ),
        styleProps.className,
      )}
    />
  );
};
